import { SignupProvider } from "@nelo/signup-lib"
import React, { useEffect, useMemo, useState } from "react"

import { PSEUDO_ID_COOKIE } from "@lib/constants"
import { getSessionCookie } from "@lib/util/get-session-cookie-client"
import { sendGoogleAnalyticsEvent } from "@modules/common/utils/analytics"
import SignupFlowSteps, { SignupFlowProps } from "@modules/signup-and-order-flow/components/signup/SignupFlowSteps"
import { getDeviceInfo } from "@modules/signup-and-order-flow/util/getDeviceInfo"
import { getFingerprintId } from "@modules/signup-and-order-flow/util/getFingerprintId"

const SignupFlow: React.FC<SignupFlowProps> = (props) => {
  const [fingerprintId, setFingerprintId] = useState<string | null>(null)
  const [isInitialized, setIsInitialized] = useState(false)

  const deviceInfo = useMemo(() => getDeviceInfo(), [])
  const pseudoId = useMemo(() => getSessionCookie(PSEUDO_ID_COOKIE) || "", [])

  useEffect(() => {
    const initFingerprint = async () => {
      try {
        const visitorId = await getFingerprintId()
        setFingerprintId(visitorId)
      } catch (error) {
        console.error("Error initializing fingerprint:", error)
      } finally {
        setIsInitialized(true)
      }
    }

    initFingerprint()
  }, [])

  const signupProviderProps = useMemo(() => {
    const analyticsFunction = (name: string, payload: Record<string, any> | null = null) => {
      sendGoogleAnalyticsEvent(name, payload)
    }

    return {
      deviceInfo,
      deviceState: {
        fingerprintDetails: fingerprintId ? { visitorId: fingerprintId } : undefined,
        location: null,
      },
      neloApiBaseUrl: process.env.NEXT_PUBLIC_NELO_API_URL || "https://api-v2.nelo.co",
      language: "es",
      sessionId: pseudoId,
      temporaryUserUuid: pseudoId,
      useSessionStorage: true,
      stronglyValidateCurp: false,
      analyticsFn: analyticsFunction,
    }
  }, [deviceInfo, fingerprintId, pseudoId])

  if (!isInitialized) {
    return <div className="flex items-center justify-center p-8">Cargando...</div>
  }

  return (
    <SignupProvider {...signupProviderProps}>
      <SignupFlowSteps {...props} />
    </SignupProvider>
  )
}
export default SignupFlow
